.input {
  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
  font: inherit;
}

.clear-button {
  right: var(--dds-spacing-x1);
}

.suggestions {
  z-index: var(--dds-zindex-dropdown);
}
